import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserAccountService } from '../services';

/**
 * Interceptor that adds JWT token to the authorization header of outgoing HTTP requests.
 */
export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const userAccountService = inject(UserAccountService);
  const currentUser = userAccountService.userJWT();
  const isLoggedIn = !!currentUser?.accessToken;
  const isApiUrl = request.url.startsWith(environment.API_URL);

  if (isLoggedIn && isApiUrl) {
    request = request.clone({
      withCredentials: true,
      setHeaders: {
        Authorization: `Bearer ${currentUser.accessToken}`,
      },
    });
  }

  return next(request);
};
